import MetadataComponent from './MetaData/MetaDataComponent';

const MetaDataComponent = () => {
  return (
    <article className="docs-article" id="section-4">
      <header className="docs-header">
        <h1 className="docs-heading">Meta Data <span className="docs-time">Last updated: 2023-06-30</span>
        </h1>
        <section className="docs-intro">
          <p>The Metadata API is an essential API that provides developers with access to transaction statuses, error codes, payment methods, and more. We strongly recommend developers to avoid hard-coding these values as they may change over time. Instead, to ensure future-proof integrations, it is advisable to use the Metadata API to retrieve the latest values dynamically. By doing so, developers can ensure their applications always operate according to the most up-to-date metadata, promoting flexibility and future-proofing their integrations.</p>
        </section>
      </header>
      <MetadataComponent />
    </article>
  )
}

export default MetaDataComponent;